
import Vue from "vue";
import Crm from "@/models/crm/crm";
import { UserInfo } from "@/models/dossier/user-info";
import { DossierService } from "@/services/dossier-service";
import { ISelectItem } from "winfakt-vue-components";
import { CrmAssignedUser } from "@/models/crm/crm-assigned-users";

export default Vue.extend({
	data() {
		return {
			users: [] as UserInfo[],
			value: [] as UserInfo[],
			items: [] as ISelectItem<UserInfo>[]
		};
	},
	props: {
		crm: {
			required: true,
			type: Object as () => Crm
		},
	},
	computed: {
		//notAddedUsers(): UserInfo[] {
		//return this.users.filter(u => this.crm.AssignedUsers.find(f => f.UserID == u.ID) == null);
		//}
	},
	methods: {
		updateItems() {
			this.items = this.users.map(a => {
				return {
					text: a.Firstname + " " + a.Lastname,
					value: a
				};
			});
		},
		updateValue() {
			for (let user of this.crm.AssignedUsers) {
				let index = this.users.findIndex(a => a.ID == user.UserID);
				if (index != -1) {
					this.value.push(this.users[index]);
				}
			}
		},
		onInput(user: UserInfo[]){
			this.crm.AssignedUsers = user.map(a => {
				return new CrmAssignedUser({
					CrmID: this.crm.ID,
					UserID: a.ID
				});
			});
		}
	},
	async created() {
		this.users = await DossierService.getUsers();
		this.updateItems();
		this.updateValue();
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
